import useSWR from 'swr'
import { authCall } from '.'
import {
  staffEstates,
  staffEstatesAccess,
  staffs,
  estateStaff,
  loggedInStaff,
  changePassword,
  removeStaff,
} from './endpoints'
import {
  CreateStaff,
  EditStaff,
  EstateStaffProfileDTO,
  IStaffEstate,
  IStaffList,
  RemoveStaffResponse,
  StaffDTO,
  StaffEstateAccess,
  StaffProfile,
  StaffProfileDTO,
  TwofaCode,
  TwoFactorAuth,
  UpdateProfileRes,
  UpdateStaffRequest,
  UploadStaffPhoto,
  UpdateStaffPassword,
  UserPermissions,
} from '../interfaces/staff'
import { ResponseStatus } from '../interfaces/common'
import { getLocal, setLocal } from '../utils/local'

const StaffService = {
  useGetStaffList: ({ page = 1, size = 15, name = '' }) => {
    const url = `${staffs}?page=${page}&limit=${size}&name=${name}`

    return useSWR(url, () => {
      return authCall<IStaffList>({
        url,
        method: 'get',
      })
    })
  },

  createStaff: (data: CreateStaff) => {
    const url = estateStaff
    return authCall<StaffDTO>({
      url,
      data,
      method: 'post',
    })
  },

  editStaff: (staffId: string, data: EditStaff) => {
    const url = `staffs/${staffId}`
    return authCall<EstateStaffProfileDTO>({
      url,
      data,
      method: 'patch',
    })
  },

  getStaffById: (staffId: string) => {
    const url = `${staffs}/${staffId}`

    return authCall<StaffDTO>({
      url,
      method: 'get',
    })
  },
  getProfile: () => {
    const url = `${staffs}/me`

    return authCall<StaffProfileDTO>({
      url,
      method: 'get',
    })
  },

  update2FA: (enable2fa: boolean) => {
    const url = `${staffs}/me/2fa?enable2fa=${enable2fa}`
    return authCall<TwoFactorAuth>({
      url,
      data: { enable2fa },
      method: 'post',
    })
  },

  verify2FA: (data: TwofaCode) => {
    const url = `${staffs}/me/2fa/verify`
    return authCall<ResponseStatus>({
      url,
      data,
      method: 'patch',
    })
  },

  getStaffEstates: () => {
    const url = `${staffEstates}`
    return authCall<IStaffEstate[]>({
      url,
      method: 'get',
    })
  },

  getStaffEstateAccess: (id: string) => {
    const url = `${staffEstatesAccess}/${id}`
    return authCall<StaffEstateAccess>({
      url,
      method: 'get',
    })
  },

  // getLoggedInStaff: () => {
  //   const url = `${loggedInStaff}`;
  //   return authCall<StaffProfile>({
  //     url,
  //     method: 'get'
  //   })
  // },

  getLoggedInStaff: async () => {
    const url = `${loggedInStaff}`
    const user = await authCall<StaffProfile>({
      url,
      method: 'get',
    })

    setLocal('user', user)

    return user
  },

  updateUserProfile: (data: UpdateStaffRequest) => {
    const url = `${loggedInStaff}`
    return authCall<UpdateProfileRes>({
      url,
      data,
      method: 'patch',
    })
  },

  updateStaffPassword: (data: UpdateStaffPassword) => {
    const url = `${changePassword}`
    return authCall<UpdateStaffPassword>({
      url,
      data: {
        oldPassword: data.oldPassword,
        password: data.newPassword,
      },
      method: 'patch',
    })
  },

  deleteStaffById: (staffId: string) => {
    const url = `${removeStaff}/${staffId}`
    return authCall<RemoveStaffResponse>({
      url,
      method: 'delete',
    })
  },
UploadStaffPhoto: (file: File) => {
 const url = `${loggedInStaff}/profile/picture`;
 const formData = new FormData()
 formData.append('file', file)

 return authCall<UploadStaffPhoto>({
  url,
  data: formData,
  method: 'put'
 })
  },
getLoggedInStaffPermission: () => {
    const user = getLocal('user')

  if (user?.isEmailVerified !== true) {
    return Promise.resolve(null)
  }
  
  const url = `${loggedInStaff}/permissions`;
  return authCall<UserPermissions>({
    url,
    method: 'get',
  });
},


}

export default StaffService